
import React, { FC, ReactComponentElement } from 'react';
import { Row, Spacer, Text, Card, Line,  } from '@components/1-atoms';
import { Button } from '@components/2-molecules';


type AccountBalanceCardProps = {
    title: string;
    style?: any;
    children?: any;
  };

const AccountBalanceCard: FC<AccountBalanceCardProps> = ({  children, title }) => {
  return (
      
      <Card>
        <Row>
          <Text large bold>{title}</Text>
        </Row>
        <Spacer h={2} />
        
        
        <Row>
          <Text xlarge bold>$ 69,05663</Text>
        </Row>
        <Spacer h={2} />
        <Line />

        <Row>
          <Button inset bg={"transparent"} large align="left" color="#005ACE" onPress={() => { }}>View transactions</Button>
        </Row>
      </Card>
  );
};

export default AccountBalanceCard;
